export default "__VITE_ASSET__c89ddd82__"